import { type DefaultRootState } from 'react-redux';
import { createCachedSelector } from 're-reselect';

const selector = createCachedSelector(
  (state: DefaultRootState, email: string | undefined | null) => state.user.data[state.user.emailMap[email || '']] || null,
  (userData) => userData ?? null,
)((state, email) => email);

export default (email?: string) => (state: DefaultRootState) => selector(state, email);
